import { getJson } from "../../auth/utils/getJson.js"; 

/** GET /api/evns */
export function fetchEVNs(signal) {
  return getJson("/api/evns", { signal }).then((json) =>
    Array.isArray(json) ? json : []
  );
}

/** GET /api/evns/:evnId */
export function fetchEVNById(evnId, signal) {
  return getJson(`/api/evns/${encodeURIComponent(evnId)}`, { signal });
}

/** GET /api/evns/codes/list */
export function fetchEVNCodesList(signal) {
  return getJson("/api/evns/codes/list", { signal }).then((json) =>
    Array.isArray(json) ? json.map((e) => e.EVN) : []
  );
}

/** GET /api/evns/:evnId/meters */
export function fetchEVNMeters(evnId, signal) {
  return getJson(`/api/evns/${encodeURIComponent(evnId)}/meters`, { signal }).then(
    (json) => (Array.isArray(json) ? json : [])
  );
}

/** GET /api/evns/:evnId/history */
export function fetchEVNHistory(evnId, signal) {
  return getJson(`/api/evns/${encodeURIComponent(evnId)}/history`, { signal }).then(
    (json) => (Array.isArray(json) ? json : [])
  );
}
